import React from 'react';
import { Home, User, Film, History, BookOpen } from 'lucide-react';

const MobileBottomNav = ({ activeSection, setActiveSection, isDark }) => {
  const navItems = [
    { id: 'stats', icon: Home, label: 'Home' },
    { id: 'history', icon: History, label: 'History' },
    { id: 'shorts', icon: Film, label: 'Shorts' },
    { id: 'diary', icon: BookOpen, label: 'Diary' },
    { id: 'profile', icon: User, label: 'Profile' }
  ];

  return (
    <nav className={`fixed bottom-0 left-0 right-0 border-t z-50 md:hidden safe-area-bottom ${isDark ? 'bg-slate-800 border-slate-700' : 'bg-white border-gray-200'}`}>
      <div className="flex justify-around items-center py-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeSection === item.id;
          return (
            <button
              key={item.id}
              onClick={() => setActiveSection(item.id)}
              className={`flex flex-col items-center justify-center py-1.5 px-3 rounded-lg transition-all ${
                isActive ? 'text-blue-600' : isDark ? 'text-gray-400' : 'text-gray-500'
              }`}
              data-testid={`mobile-nav-${item.id}`}
            >
              <Icon className={`h-5 w-5 ${isActive ? 'stroke-[2.5px]' : ''}`} />
              <span className="text-[10px] mt-0.5 font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
